import AxiosConfig from '../../../config/AxiosConfig';

const useRefundOrder = () => {
  const refundOrder = async (refundId, profile) => {
    console.log('refundOrder');
    try {
      const response = await AxiosConfig.create(
        'put',
        `/refunds/${refundId}/validate`
      )
        .call({
          status: 'REFUNDEDFI',
          actionBy: profile?._id,
          serviceName: 'finance',
          refusedDescription: null,
          autoRefund: true,
        })
        .getResponseData();

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return { refundOrder };
};

export default useRefundOrder;
